import { Link } from "react-router-dom";
import { Heart, Users, Church } from "lucide-react";

/**
 * Group detail header — title, optional church link, optional description,
 * member + prayer counts. Pure presentation.
 */
export function GroupHeader({ group, memberCount, prayerCount }) {
  return (
    <>
      {group.is_disabled && (
        <div
          className="mb-6 bg-red-50 border border-red-200 rounded-xl px-4 py-3 flex items-center gap-3"
          data-testid="group-disabled-banner"
        >
          <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0">
            <Heart className="w-4 h-4 text-red-500" />
          </div>
          <div>
            <p className="font-medium text-red-700 text-sm">This group is disabled</p>
            <p className="text-xs text-red-600/70">
              Disabled groups are hidden from regular users. Only admins can view and manage them.
            </p>
          </div>
        </div>
      )}

      <div className="mb-8">
        <h1
          className="font-serif text-2xl sm:text-3xl font-semibold text-stone-dark mb-2"
          data-testid="group-title"
        >
          {group.name}
        </h1>
        {group.church_name && (
          <Link
            to={`/churches/${group.church_id}`}
            className="inline-flex items-center gap-1.5 text-sm text-sage hover:text-sage-dark transition-colors mb-1"
            data-testid="group-church-link"
          >
            <Church className="w-4 h-4" />
            {group.church_name}
          </Link>
        )}
        {group.description && <p className="text-stone-dark/60">{group.description}</p>}
        <div className="flex items-center gap-4 mt-3 text-sm text-stone-dark/50">
          <span className="flex items-center gap-1">
            <Users className="w-4 h-4" />
            {memberCount} member{memberCount !== 1 ? "s" : ""}
          </span>
          <span className="flex items-center gap-1">
            <Heart className="w-4 h-4" />
            {prayerCount} prayer{prayerCount !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </>
  );
}
